import React from 'react';
import { CheckCircleIcon, ClockIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';

const ProcessingStatus = ({ taskStatus, statusMessage }) => {
  const getStatusIcon = () => {
    switch (taskStatus) {
      case 'completed':
        return <CheckCircleIcon className="h-12 w-12 text-green-500" />;
      case 'failed':
        return <ExclamationTriangleIcon className="h-12 w-12 text-red-500" />;
      default:
        return <ClockIcon className="h-12 w-12 animate-pulse text-blue-500" />;
    }
  };

  const getStatusColor = () => {
    switch (taskStatus) {
      case 'completed':
        return 'text-green-600';
      case 'failed':
        return 'text-red-600';
      default:
        return 'text-blue-600';
    }
  };

  return (
    <div className="flex flex-col items-center justify-center text-center">
      <div className="flex items-center justify-center">{getStatusIcon()}</div>
      <h2 className="mt-4 text-lg font-medium text-gray-900">
        {taskStatus === 'completed' && 'Task Completed!'}
        {taskStatus === 'failed' && 'Task Failed'}
        {taskStatus === 'processing' && 'Processing Task'}
      </h2>
      <p className={`mt-2 text-sm ${getStatusColor()}`}>{statusMessage}</p>
    </div>
  );
};

export default ProcessingStatus;
